export default __webpack_public_path__ + "static/media/twitch.ac695fcc.svg";